import Nullstack from 'nullstack';
export default function IconBrandNytimes({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-nytimes",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11.036 5.058a8.001 8.001 0 1 0 8.706 9.965"
  }), "   ", Nullstack.element("path", {
    d: "M12 21v-11l-7.5 4"
  }), "   ", Nullstack.element("path", {
    d: "M17.5 3a2.5 2.5 0 1 1 0 5l-11 -5a2.5 2.5 0 0 0 -.67 4.91"
  }), "   ", Nullstack.element("path", {
    d: "M9 12v8"
  }), "   ", Nullstack.element("path", {
    d: "M16 13h-.01"
  }), " ");
}